import React from 'react';
import './Loader.css';

const Loader = () => (
  <div className="loader">
    <div className="loader-dots">
      <div className="loader-dot" />
      <div className="loader-dot" />
      <div className="loader-dot" />
    </div>
  </div>
);

export default Loader;
